import { Route } from "react-router-dom";
import WorkerDashboard from "../components/worker_panel_dashboard";
import WorkerAddJob from "../components/Jobboard/add_job";
import WorkerAddJobShift from "../components/Jobboard/add_job_shift";
import WorkerMyJob from "../components/Jobboard/my_job";
import WorkerShiftJobs from "../components/Jobboard/job_list_shift";
import DashboardHome from "../components/worker_home";
import WorkerVerify from "../components/worker_verify";
import WorkerCompliance from "../components/compliance";
import WorkerAddCompliance from "../components/add_compliance";
import WorkerJobDetails from "../components/Jobboard/details_job";
import WorkerShiftJobDetails from "../components/Jobboard/job_details_shift";
import WorkerEditJob from "../components/Jobboard/edit_job";
import WorkerEditJobShift from "../components/Jobboard/edit_job_shift";
import WorkerResumeList from "../components/Jobboard/resume_list";
import WorkerResumeDetails from "../components/Jobboard/resume_details";
import WorkerAddResume from "../components/Jobboard/add_resume";
import WorkerEditResume from "../components/Jobboard/edit_resume";
import WorkerJobByTypeCount from "../components/Jobboard/jobByType";
import WorkerJobByExperienceCount from "../components/Jobboard/jobByExperience";
import WorkerSkillsByResumeCount from "../components/Jobboard/skillsByResume";
import WorkerJobApplications from "../components/Jobboard/job_applications";
import WorkerJobApplicationsShift from "../components/Jobboard/job_applications_shift";
import WorkerShiftRequestDetails from "../components/job_request_details";
// import WorkerJobDetails from "../components/Jobboard/details_job.";
// import WorkerEditJob from "../components/Jobboard/edit_job";
import WorkerDownload from "../components/worker_download";
import WorkerEditProfile from "../components/worker_editprofile";
import WorkerPlans from "../components/worker_plans";
import WorkerApplyJob from "../components/Jobboard/apply_job";
import WorkerUserResumeDetails from "../components/Jobboard/resume_user_details";
import WorkerJobByCategoriesCount from "../components/Jobboard/job_by_categories";
import WorkerJobByStatesCount from "../components/Jobboard/job_by_states";
import WorkerShiftRequestLogs from "../components/Jobboard/shift_request_logs";
import WorkerShiftJobRequest from "../components/job_requests";
import EmployerAssigendJobs from "../components/Jobboard/emp_assigned_job";
import EmployerAssigendJobDetails from "../components/Jobboard/emp_assigend_job_logs";
import WorkerAddWorkTime from "../components/Jobboard/add_worktime";
import WorkerAcceptedJobs from "../components/Jobboard/accepted_job";
import ProvidersEmployees from "../components/providers_employees";
// import ProviderBenefitBoundaryBot from "../components/Provider Benefit Boundary Bot/provider_benefit_boundary_bot";
import BenefitsStabilityIntake from "../components/Provider Benefit Boundary Bot/provider_benefit_boundary_bot";

import RequireRole from "../../worker-middleware/components/RequireRole";

const WorkerPanelRoutes = () => (
  <>
    {/* <Route path="panel" element={<WorkerDashboard />}>
      <Route index element={<DashboardHome />} />
      <Route path="add-job" element={<WorkerAddJob />} />
      <Route path="my-job" element={<WorkerMyJob />} />
      <Route path="job-details/:id" element={<WorkerJobDetails />} />
      <Route path="edit-job/:id" element={<WorkerEditJob />} />
      <Route path="verify" element={<WorkerVerify />} />
      <Route path="compliance" element={<WorkerCompliance />} />
      <Route path="resume-list" element={<WorkerResumeList />} />
      <Route path="add-resume" element={<WorkerAddResume />} />
      <Route path="edit-resume/:id" element={<WorkerEditResume />} />
      <Route path="resume-details/:id" element={<WorkerResumeDetails />} />
      <Route path="job-by-type" element={<WorkerJobByTypeCount />} />
      <Route path="job-by-experience" element={<WorkerJobByExperienceCount />} />
      <Route path="skills-by-resume" element={<WorkerSkillsByResumeCount />} />
      <Route path="job-applications" element={<WorkerJobApplications />} />
    </Route>
      <Route path="add-compliance" element={<WorkerAddCompliance />} /> */}

    <Route path="panel" element={<WorkerDashboard />}>

      {/* ✅ Dashboard – ALL ROLES */}
      <Route index element={<DashboardHome />} />

      <Route path="editprofile" element={<WorkerEditProfile />} />
      <Route path="myplans" element={<WorkerPlans />} />
      <Route path="shift-request-logs/:id" element={<WorkerShiftRequestLogs />} />

      {/* ✅ COMMON – ALL ROLES */}


      <Route path="verify" element={<WorkerVerify />} />

      {/* 🔐 JOB ROLE (role_id === 3) */}
      <Route element={<RequireRole allowedRoles={[3]} />}>
        <Route path="add-job" element={<WorkerAddJob />} />
        <Route path="add-shift-job" element={<WorkerAddJobShift />} />
        <Route path="my-job" element={<WorkerMyJob />} />
        <Route path="shift-jobs" element={<WorkerShiftJobs />} />
        <Route path="shift-job-details/:id" element={<WorkerShiftJobDetails />} />
        <Route path="edit-job/:id" element={<WorkerEditJob />} />
        <Route path="edit-shift-job/:id" element={<WorkerEditJobShift />} />
        <Route path="skills-by-resume" element={<WorkerSkillsByResumeCount />} />
        <Route path="job-applications" element={<WorkerJobApplications />} />
        <Route path="job-shift-applications" element={<WorkerJobApplicationsShift />} />
        <Route path="assigned-shift-jobs" element={<EmployerAssigendJobs />} />
        <Route path="assigned-shift-job-details/:id" element={<EmployerAssigendJobDetails />} />
        <Route path="providers-employees" element={<ProvidersEmployees />} />
        <Route path="provider-benefit-boundary-setup" element={<BenefitsStabilityIntake />} />
      </Route>

      {/* 🔐 RESUME ROLES (4,5,6) */}
      <Route element={<RequireRole allowedRoles={[4, 5, 6]} />}>
        <Route path="resume-list" element={<WorkerResumeList />} />
        <Route path="add-resume" element={<WorkerAddResume />} />
        <Route path="edit-resume/:id" element={<WorkerEditResume />} />
        <Route path="resume-details/:id" element={<WorkerResumeDetails />} />
        <Route path="shift-request-details/:id" element={<WorkerShiftRequestDetails />} />
        <Route path="job-by-type" element={<WorkerJobByTypeCount />} />
        <Route path="job-by-experience" element={<WorkerJobByExperienceCount />} />
        <Route path="job-by-categories" element={<WorkerJobByCategoriesCount />} />
        <Route path="job-by-states" element={<WorkerJobByStatesCount />} />
        <Route path="download" element={<WorkerDownload />} />
        <Route path="apply-jobs" element={<WorkerApplyJob />} />
        <Route path="shift-job-request" element={<WorkerShiftJobRequest />} />
        <Route path="add-worktime" element={<WorkerAddWorkTime />} />
        <Route path="accepted-jobs" element={<WorkerAcceptedJobs />} />

        {/* <Route path="compliance" element={<WorkerCompliance />} />
        <Route path="add-compliance" element={<WorkerAddCompliance />} /> */}
      </Route>

      <Route element={<RequireRole allowedRoles={[5, 6]} />}>
        <Route path="compliance" element={<WorkerCompliance />} />
        <Route path="add-compliance" element={<WorkerAddCompliance />} />
      </Route>

      {/* 🔐 COMPLIANCE (NOT for 4,5,6) */}
      <Route element={<RequireRole allowedRoles={[1, 2, 3]} />}>
      </Route>
    </Route>
    <Route path="job-details/:id" element={<WorkerJobDetails />} />
    <Route path="resume-user-detail/:id" element={<WorkerUserResumeDetails />} />

  </>
);

export default WorkerPanelRoutes;
